import { Injectable }                 from '@angular/core';
import { AbstractBaseService }        from '@app/core/bases/services/abstractBaseService';
import { TenantApiService }           from '@app/core/http/tenants/tenant-api.service';
import {
	Tenant,
	TenantStatistics,
	TenantStatusEnum
}                                     from '@app/modules/admin-tenant/models/tenant.model';
import {
	NotificationConfig,
	SchedulingConfig
}                                     from '@app/modules/configuration/models/configuration.model';
import { RequestCompleteEntityState } from '@core/interfaces/api.interface';
import { IStoreConfig }               from '@core/interfaces/store.interface';
import { Store }                      from '@ngrx/store';
import {
	BehaviorSubject,
	Observable
}                                     from 'rxjs';

@Injectable( { providedIn: 'root' } )
export class TenantService extends AbstractBaseService {

	readonly TENANT_STATUS_ENUM = TenantStatusEnum;

	statistics$: BehaviorSubject<RequestCompleteEntityState<TenantStatistics>> = new BehaviorSubject<RequestCompleteEntityState<TenantStatistics>>( null );

	constructor(
		private readonly tenantApi: TenantApiService,
		protected readonly store$: Store
	) {
		// TODO replace null args with selector/actions from store
		super( store$, null, null );
	}

	// STATE SELECTOR ###########################################################################

	// STORE SELECTOR ###########################################################################


	// REQUESTS #################################################################################
	currentUsersTenant(): Observable<RequestCompleteEntityState<Tenant>> {
		return this.tenantApi.currentUsersTenant();
	}

	// TODO: This should be changed to use store (April 2020)
	// loadStatistics() {
	// 	this.tenantApi.statistics()
	// 		.pipe(take(1))
	// 		.subscribe(statisticsState => {
	// 			this.statistics$.next(statisticsState);
	// 		});
	// }

	statistics(): Observable<RequestCompleteEntityState<TenantStatistics>> {
		return this.statistics$.asObservable();
	}

	// Scheduling Config
	readSchedulingConfig( withFullResponse: boolean, storeConfig?: IStoreConfig ): Observable<RequestCompleteEntityState<SchedulingConfig>> {
		const storeProcessingConfig = this.createEntityStoreProcessingConfig<SchedulingConfig>(
			storeConfig,
			null,
			null
		);

		const req$ = this.tenantApi.readSchedulingConfig( withFullResponse );
		return this.requestEntityThroughProxy<SchedulingConfig>( null, req$, storeProcessingConfig );
	}

	createSchedulingConfig( configuration: SchedulingConfig, storeConfig?: IStoreConfig ): Observable<RequestCompleteEntityState<SchedulingConfig>> {
		const storeProcessingConfig = this.createEntityStoreProcessingConfig<SchedulingConfig>(
			storeConfig,
			null,
			null
		);

		const req$ = this.tenantApi.createSchedulingConfig( configuration );
		return this.requestEntityThroughProxy<SchedulingConfig>( null, req$, storeProcessingConfig );
	}

	updateSchedulingConfig( configuration: SchedulingConfig, storeConfig?: IStoreConfig ): Observable<RequestCompleteEntityState<SchedulingConfig>> {
		const storeProcessingConfig = this.createEntityStoreProcessingConfig<SchedulingConfig>(
			storeConfig,
			null,
			null
		);

		const req$ = this.tenantApi.updateSchedulingConfig( configuration );
		return this.requestEntityThroughProxy<SchedulingConfig>( null, req$, storeProcessingConfig );
	}


	// Notification Config
	readNotificationConfig( withFullResponse = true, storeConfig?: IStoreConfig ): Observable<RequestCompleteEntityState<NotificationConfig>> {
		const storeProcessingConfig = this.createEntityStoreProcessingConfig<NotificationConfig>(
			storeConfig,
			null,
			null
		);

		const req$ = this.tenantApi.readNotificationConfig( withFullResponse );
		return this.requestEntityThroughProxy<NotificationConfig>( null, req$, storeProcessingConfig );
	}

	createNotificationConfig(
		configuration: NotificationConfig, withFullResponse = true, storeConfig?: IStoreConfig ): Observable<RequestCompleteEntityState<NotificationConfig>> {
		const storeProcessingConfig = this.createEntityStoreProcessingConfig<NotificationConfig>(
			storeConfig,
			null,
			null
		);

		const req$ = this.tenantApi.createNotificationConfig( configuration );
		return this.requestEntityThroughProxy<NotificationConfig>( null, req$, storeProcessingConfig );
	}

	updateNotificationConfig(
		configuration: NotificationConfig, withFullResponse = true, storeConfig?: IStoreConfig ): Observable<RequestCompleteEntityState<NotificationConfig>> {
		const storeProcessingConfig = this.createEntityStoreProcessingConfig<NotificationConfig>(
			storeConfig,
			null,
			null
		);

		const req$ = this.tenantApi.updateNotificationConfig( configuration );
		return this.requestEntityThroughProxy<NotificationConfig>( null, req$, storeProcessingConfig );
	}
}
